export default {
  backend_uri: 'https://api.mediscribe.pranaa.in',
  // backend_uri: 'http://localhost:8002',
  language: 'en',
  logo_path: '/logo.svg',
};
  
